import React, { useState } from 'react';
import { Plus, Tag } from 'lucide-react';
import CreateExpenseModal from './CreateExpenseModal';
import CreateCategoryModal from './CreateCategoryModal';
import { ExpenseCreateRequest, Category } from '../types';

interface UnifiedCreateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmitExpense: (expense: ExpenseCreateRequest) => Promise<void>;
  onSubmitCategory: (name: string, parentId: number | null) => Promise<void>;
  loadingExpense: boolean;
  loadingCategory: boolean;
  categories: Category[];
  currencies: string[];
  categoriesLoading: boolean;
  initialMode?: 'expense' | 'category';
}

const UnifiedCreateModal: React.FC<UnifiedCreateModalProps> = ({
  isOpen,
  onClose,
  onSubmitExpense,
  onSubmitCategory,
  loadingExpense,
  loadingCategory,
  categories,
  currencies,
  categoriesLoading,
  initialMode = 'expense'
}) => {
  const [mode, setMode] = useState<'expense' | 'category'>(initialMode);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="expense-modal modal-with-tabs" onClick={(e) => e.stopPropagation()}>
        {/* Mode Switcher */}
        <div className="modal-tabs">
          <button
            className={`modal-tab ${mode === 'expense' ? 'active' : ''}`}
            onClick={() => setMode('expense')}
            disabled={loadingExpense || loadingCategory}
          >
            <Plus size={16} />
            <span>Add Expense</span>
          </button>
          <button
            className={`modal-tab ${mode === 'category' ? 'active' : ''}`}
            onClick={() => setMode('category')}
            disabled={loadingExpense || loadingCategory}
          >
            <Tag size={16} />
            <span>Add Category</span>
          </button>
        </div>

        {/* Render form content without overlay */}
        {mode === 'expense' ? (
          <CreateExpenseModal
            isOpen={true}
            onClose={onClose}
            onSubmit={onSubmitExpense}
            loading={loadingExpense}
            categories={categories}
            currencies={currencies}
            categoriesLoading={categoriesLoading}
            hideWrapper={true}
          />
        ) : (
          <CreateCategoryModal
            isOpen={true}
            onClose={onClose}
            onSubmit={onSubmitCategory}
            loading={loadingCategory}
            categories={categories}
            hideWrapper={true}
          />
        )}
      </div>
    </div>
  );
};

export default UnifiedCreateModal;
